import { classes } from '../utils/classes.ts';
import css from './Logo.module.css';

interface Props {
  readonly class?: string;
}

export const Logo = ({ class: outerClass }: Props) => {
  return (
    <h1 class={classes(css.title, outerClass)}>
      <span class={css.titleLeft}>Sea</span>
      <span class={css.titleRight}>hax</span>
    </h1>
  );
};
